import React, { useState, useEffect } from 'react';
import {
    CircularProgress,
} from '@mui/material';

import { useAppState } from "./AppStateContext";

const Account = () => {
    const { apiGet } = useAppState();

    const [accountData, setAccountData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);

    const fetchAccountData = async () => {
        try {
            const response = await apiGet(`account`);
            setAccountData(response.data);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } catch (error) {
            console.error('Failed to fetch account data', error);
            setErrorMessage('An error occurred while trying to load the account data.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAccountData();
    }, []);

    return (
        isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <CircularProgress />
            </div>
        ) : errorMessage ? (
            <p style={{ color: 'red', padding: '20px' }}>{errorMessage}</p>
        ) : (
            <div>
                <h1>Account</h1>
                <p>School name: <strong>{accountData.name}</strong></p>
                <p>Subscription valid until: <strong>{(new Date(accountData.subscription_end_date)).toLocaleDateString()}</strong></p>
                <p>Number of student licenses: <strong>{accountData.subscription_seats}</strong></p>
                <p>Unused licenses: <strong>{accountData.subscription_seats - accountData.seated_student_count}</strong></p>
                <p>To add licenses or prolong your subscription, please write to <a href="mailto:legentibus@latinitium.com">legentibus@latinitium.com</a></p>
            </div>
        )
    );
};

export default Account;
